import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0c7232a4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=0c7232a4&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=0c7232a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7232a4",
  null
  
)

export default component.exports